'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      document = _ref.document,
      navigator = _ref.navigator,
      chrome = _ref.chrome;

  if (!Function.prototype.bind) {
    return true;
  }

  if (!document || !navigator) {
    return true;
  }
  var webdriver = navigator.webdriver,
      languages = navigator.languages,
      userAgent = navigator.userAgent,
      plugins = navigator.plugins;

  if (webdriver) {
    return true;
  }

  if (!userAgent) {
    return true;
  }
  if (userAgent.indexOf('Chrome') > 0) {
    if (!chrome) {
      return true;
    }
    if (!plugins || plugins.length === 0 || plugins.push) {
      return true;
    }
  }

  if (userAgent.indexOf('Snapchat') > 0 && document.hidden) {
    return true;
  }

  if (!languages || languages.length === 0) {
    return true;
  }
  try {
    languages.push('x');
    languages.pop();
    return true;
  } catch (e) {
    // empty
  }

  try {
    null[0]();
  } catch (e) {
    var _ref2 = e || {},
        stack = _ref2.stack;

    if (stack && /ph\x61n\x74om|n\x6fde[^_]/i.test(stack)) {
      return true;
    }
  }

  return false;
};
//# sourceMappingURL=isSuspectedBot.js.map